import type { Tag } from "../../MarketingEvents/MarketingDataDefinitions";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const pintrk: any;
export default class PinterestTagSignUpEvent implements Tag {
  leadType = "";

  private readonly eventName = "signup";

  public eventId = "";

  constructor(leadType: string) {
    this.leadType = leadType;
  }

  sendEvent(): void {
    if (typeof pintrk === "function") {
      pintrk("track", this.eventName, {
        lead_type: this.leadType,
        event_id: this.eventId,
      });
    }
  }
}
